export default __webpack_public_path__ + "static/media/Buff_HTB.43d97c30.md";